import * as React from 'react'
import { Card, CardContent, Image, Popup } from 'semantic-ui-react'

type IIngotItemProps = {
    gameItem: IIngotItemInfo,
    onClickItem?: React.MouseEventHandler<HTMLAnchorElement>
}

export const IngotItem: React.SFC<IIngotItemProps> = (props) => {
    const {gameItem, onClickItem} = props
    return (
        <Popup
            trigger={<Card className="card-small" onClick={onClickItem}>
                <CardContent textAlign="center" className={'card-content-small ingot'}>
                    <div className={'card-label-small'}>
                        {gameItem.value}
                    </div>
                </CardContent>
                <Image style={{width: '150px', height: '50px'}} src={gameItem.image}/>
                <CardContent textAlign="center" className={'card-content-small ingot'}>
                    <div className={'card-label-small'} style={{fontSize: '8pt'}}>
                        In stock: {gameItem.num}
                    </div>
                </CardContent>
            </Card>}
            content={gameItem.name}
        />
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/ExchangeStore/IngotItem.tsx